<mat-toolbar style="background-color: green; color: white">
  <span>Deloitte Spark Application Simulator - OIDC</span>
  <span class="spacer"></span>
  <ng-container *ngIf="isAuthenticated()">
    <div><a class="link" href="#">My Profile</a></div>
    <div class="username"><mat-icon>person</mat-icon>{{userName}}</div>
    <button mat-icon-button (click)="logout()" matTooltip="Log Out">
      <mat-icon>logout</mat-icon>
    </button>
  </ng-container>
</mat-toolbar>

<div class="container">
  <div *ngIf="!isAuthenticated()" class="centered">
    <div class="white_box">
      <div>
        <h4>Existing User</h4>
        <button
          mat-raised-button
          style="
            background-color: white;
            color: green;
            width: 200px;
            height: 60px;
          "
          (click)="login()"
        >
          <mat-icon>login</mat-icon>
          Sign In
        </button>
      </div>
      <div>
        <h4>New User</h4>
        <button
          class="register_button"
          mat-raised-button
          style="
            background-color: green;
            color: white;
            width: 200px;
            height: 60px;
          "
          (click)="register()"
        >
          <mat-icon>person_add</mat-icon>
          Register
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isAuthenticated()" class="content">
    <!-- Access Token Card -->
    <mat-card class="token-card">
      <mat-card-header>
        <mat-icon matCardAvatar>vpn_key</mat-icon>
        <mat-card-title>Access Token</mat-card-title>
        <mat-card-subtitle>Your OAuth access token</mat-card-subtitle>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Show Access Token </mat-panel-title>
          </mat-expansion-panel-header>
          <pre>{{ accessToken }}</pre>
        </mat-expansion-panel>
        <button
          mat-icon-button
          (click)="copyToClipboard(accessToken)"
          matTooltip="Copy to Clipboard"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>

    <!-- ID Token Card -->
    <mat-card class="token-card">
      <mat-card-header>
        <mat-icon matCardAvatar>fingerprint</mat-icon>
        <mat-card-title>ID Token</mat-card-title>
        <mat-card-subtitle>Your OAuth ID token</mat-card-subtitle>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Show ID Token </mat-panel-title>
          </mat-expansion-panel-header>
          <pre>{{ idToken }}</pre>
        </mat-expansion-panel>
        <button
          mat-icon-button
          (click)="copyToClipboard(idToken)"
          matTooltip="Copy to Clipboard"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>
